function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f0a2cd87-7f6e-4358-9461-76ce48d716bc",
  y1: 105.97,
  x2: 355.07,
  y2: 105.97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#010f28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#030b21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#050517"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a5bb56a1-b8f2-49be-b308-11affbd14eca",
  x1: 90.42,
  y1: 219.66,
  x2: 445.49,
  y2: 219.66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007ec5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#0072b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#02588f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#02426e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#032f53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#041f3d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#04132c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#050b20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#050619"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#050517"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 355.07,
  height: 211.95,
  rx: 2.81,
  fill: "url(#f0a2cd87-7f6e-4358-9461-76ce48d716bc)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M441.49,117.69v204H94.42V117.69H441.49m1.19-4H93.23a2.81,2.81,0,0,0-2.81,2.81V322.83a2.81,2.81,0,0,0,2.81,2.81H442.68a2.81,2.81,0,0,0,2.81-2.81V116.5a2.81,2.81,0,0,0-2.81-2.81Z",
  transform: "translate(-90.42 -113.69)",
  fill: "url(#a5bb56a1-b8f2-49be-b308-11affbd14eca)"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "211.95 270.02 141.3 270.02 150.72 214.85 202.53 214.85 211.95 270.02",
  fill: "#0b0b1e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M343,392.42H192v-5.71a3,3,0,0,1,3-3H340a3,3,0,0,1,3,3Z",
  transform: "translate(-90.42 -113.69)",
  fill: "#2a2acc"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("rect", {
  x: 14.19,
  y: 91.55,
  width: 101.95,
  height: 60.85,
  rx: 2.81,
  fill: "#373763"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.61,208.63h0a4.14,4.14,0,0,1,4.15-4.14h93.65a4.14,4.14,0,0,1,4.15,4.14h0",
  transform: "translate(-90.42 -113.69)",
  fill: "#3535bc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105.07,
  cy: 93.01,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108.02,
  cy: 93.01,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.97,
  cy: 93.01,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.78,
  y1: 98.17,
  x2: 18.78,
  y2: 146.85,
  fill: "none",
  stroke: "#e1e1ef",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 100.39,
  r: 0.74,
  fill: "#7d7dd3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 135.79,
  r: 0.74,
  fill: "#7d7dd3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 104.81,
  r: 0.74,
  fill: "#d1d1f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 131.36,
  r: 0.74,
  fill: "#d1d1f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 109.24,
  r: 0.74,
  fill: "#5d5da3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 113.66,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 144.64,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 140.21,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 118.09,
  r: 0.74,
  fill: "#a1c11e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 122.51,
  r: 0.74,
  fill: "#841fbf"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22.47,
  cy: 126.94,
  r: 0.74,
  fill: "#0d7cba"
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 100.39,
  x2: 48.28,
  y2: 100.39,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 79.26,
  y1: 113.66,
  x2: 105.07,
  y2: 113.66,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 74.83,
  y1: 122.51,
  x2: 100.65,
  y2: 122.51,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 51.97,
  y1: 104.81,
  x2: 80,
  y2: 104.81,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 131.36,
  x2: 49.02,
  y2: 131.36,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 104.81,
  x2: 48.28,
  y2: 104.81,
  fill: "none",
  stroke: "#e8e5d1",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 126.94,
  x2: 54.92,
  y2: 126.94,
  fill: "none",
  stroke: "#994154",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 58.61,
  y1: 126.94,
  x2: 85.9,
  y2: 126.94,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 73.36,
  y1: 131.36,
  x2: 100.65,
  y2: 131.36,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 54.18,
  y1: 100.39,
  x2: 74.83,
  y2: 100.39,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 68.2,
  y1: 118.09,
  x2: 96.22,
  y2: 118.09,
  fill: "none",
  stroke: "#419cce",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 85.16,
  y1: 104.81,
  x2: 105.81,
  y2: 104.81,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 113.66,
  x2: 48.28,
  y2: 113.66,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 45.33,
  y1: 118.09,
  x2: 65.98,
  y2: 118.09,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 51.23,
  y1: 131.36,
  x2: 71.88,
  y2: 131.36,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 27.63,
  y1: 122.51,
  x2: 48.28,
  y2: 122.51,
  fill: "none",
  stroke: "#660fb2",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 52.71,
  y1: 122.51,
  x2: 73.36,
  y2: 122.51,
  fill: "none",
  stroke: "#906db5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 79.26,
  y1: 100.39,
  x2: 105.07,
  y2: 100.39,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 51.23,
  y1: 113.66,
  x2: 77.05,
  y2: 113.66,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 88.11,
  y1: 126.94,
  x2: 105.07,
  y2: 126.94,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 28.81,
  y1: 108.29,
  x2: 27.63,
  y2: 111.45,
  fill: "none",
  stroke: "#b5b3a3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(28.78 110.83)",
  fontSize: 2.46,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*"), /*#__PURE__*/React.createElement("line", {
  x1: 104.15,
  y1: 108.34,
  x2: 102.75,
  y2: 111.4,
  fill: "none",
  stroke: "#bfbba3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(-1, 0, 0, 1, 102.89, 110.83)",
  fontSize: 2.46,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(30.44 111.34)",
  fontSize: 7.38,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(65.85 111.34)",
  fontSize: 7.38,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(91.73 143.66)",
  fontSize: 6.85,
  fill: "#4d4d8c",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  xmlSpace: "preserve"
}, " { }")));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("rect", {
  x: 191.3,
  y: 45.1,
  width: 101.95,
  height: 60.85,
  rx: 2.81,
  fill: "#373763"
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.72,162.18h0a4.14,4.14,0,0,1,4.14-4.15h93.66a4.14,4.14,0,0,1,4.14,4.15h0",
  transform: "translate(-90.42 -113.69)",
  fill: "#3535bc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 282.18,
  cy: 46.56,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 285.13,
  cy: 46.56,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 288.08,
  cy: 46.56,
  r: 0.74,
  fill: "#d6d6ed"
}), /*#__PURE__*/React.createElement("line", {
  x1: 195.89,
  y1: 51.72,
  x2: 195.89,
  y2: 100.4,
  fill: "none",
  stroke: "#e1e1ef",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 53.93,
  r: 0.74,
  fill: "#7d7dd3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 89.33,
  r: 0.74,
  fill: "#7d7dd3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 58.36,
  r: 0.74,
  fill: "#d1d1f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 84.91,
  r: 0.74,
  fill: "#d1d1f2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 62.78,
  r: 0.74,
  fill: "#5d5da3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 67.21,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 98.18,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 93.76,
  r: 0.74,
  fill: "#428acc"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 71.63,
  r: 0.74,
  fill: "#a1c11e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 76.06,
  r: 0.74,
  fill: "#841fbf"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.58,
  cy: 80.48,
  r: 0.74,
  fill: "#0d7cba"
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 53.93,
  x2: 225.39,
  y2: 53.93,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 256.37,
  y1: 67.21,
  x2: 282.18,
  y2: 67.21,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 251.94,
  y1: 76.06,
  x2: 277.75,
  y2: 76.06,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 229.08,
  y1: 58.36,
  x2: 257.1,
  y2: 58.36,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 84.91,
  x2: 226.13,
  y2: 84.91,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 58.36,
  x2: 225.39,
  y2: 58.36,
  fill: "none",
  stroke: "#e8e5d1",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 80.48,
  x2: 232.03,
  y2: 80.48,
  fill: "none",
  stroke: "#994154",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 235.72,
  y1: 80.48,
  x2: 263,
  y2: 80.48,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 250.47,
  y1: 84.91,
  x2: 277.75,
  y2: 84.91,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 231.29,
  y1: 53.93,
  x2: 251.94,
  y2: 53.93,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 245.3,
  y1: 71.63,
  x2: 273.33,
  y2: 71.63,
  fill: "none",
  stroke: "#419cce",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 262.27,
  y1: 58.36,
  x2: 282.92,
  y2: 58.36,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 67.21,
  x2: 225.39,
  y2: 67.21,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 222.44,
  y1: 71.63,
  x2: 243.09,
  y2: 71.63,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 228.34,
  y1: 84.91,
  x2: 248.99,
  y2: 84.91,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 204.74,
  y1: 76.06,
  x2: 225.39,
  y2: 76.06,
  fill: "none",
  stroke: "#660fb2",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 229.81,
  y1: 76.06,
  x2: 250.47,
  y2: 76.06,
  fill: "none",
  stroke: "#906db5",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 256.37,
  y1: 53.93,
  x2: 282.18,
  y2: 53.93,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 228.34,
  y1: 67.21,
  x2: 254.15,
  y2: 67.21,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 265.22,
  y1: 80.48,
  x2: 282.18,
  y2: 80.48,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 205.92,
  y1: 61.84,
  x2: 204.74,
  y2: 64.99,
  fill: "none",
  stroke: "#b5b3a3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(205.89 64.38)",
  fontSize: 2.46,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*"), /*#__PURE__*/React.createElement("line", {
  x1: 281.26,
  y1: 61.88,
  x2: 279.86,
  y2: 64.95,
  fill: "none",
  stroke: "#bfbba3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(-1, 0, 0, 1, 280, 64.38)",
  fontSize: 2.46,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(207.55 64.89)",
  fontSize: 7.38,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(242.95 64.89)",
  fontSize: 7.38,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(226.48 98.68)",
  fontSize: 11.8,
  fill: "#6d6de2",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "&lt; / &gt;"), /*#__PURE__*/React.createElement("text", {
  transform: "translate(268.83 97.21)",
  fontSize: 6.85,
  fill: "#4d4d8c",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  xmlSpace: "preserve"
}, " { }")));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 35.67,
  y: 37.74,
  width: 92.91,
  height: 40.65,
  rx: 10.72,
  fill: "#343470"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "101.91 78.39 110.33 78.39 106.12 85.69 101.91 92.98 97.7 85.69 93.49 78.39 101.91 78.39",
  fill: "#393977"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 201.93,
  y: 244.41,
  width: 73.14,
  height: 32,
  rx: 11.44,
  transform: "translate(386.57 407.13) rotate(-180)",
  fill: "#343470"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "131.85 162.72 125.22 162.72 128.53 168.46 131.85 174.2 135.16 168.46 138.48 162.72 131.85 162.72",
  fill: "#393977"
});

var _ref13 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(55.44 64.21)",
  fontSize: 20.32,
  fill: "#dddded",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "React");

var _ref14 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(253.71 253.66)",
  fontSize: 17.42,
  fill: "#2a2acc",
  fontFamily: "Avenir-Roman, Avenir"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4.84,
  y: 0,
  fill: "#dadaea"
}, "{ "), /*#__PURE__*/React.createElement("tspan", {
  x: 15.49,
  y: 0,
  fill: "#dadaea",
  fontSize: 14.52,
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "React Native"), /*#__PURE__*/React.createElement("tspan", {
  x: 103.94,
  y: 0,
  xmlSpace: "preserve",
  fill: "#dadaea"
}, " }"));

var _ref15 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(133.46 152.27)",
  fontSize: 17.42,
  fill: "#d6d6ea",
  fontFamily: "Avenir-Roman, Avenir"
}, "CSS");

var _ref16 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(115.79 192.16)",
  fontSize: 17.42,
  fill: "#d6d6ea",
  fontFamily: "Avenir-Roman, Avenir"
}, ". #");

var _ref17 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(369.43 41.11)",
  fontSize: 14.52,
  fill: "#dfdfef",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "HTML /");

var _ref18 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(232.45 23.84)",
  fontSize: 14.52,
  fill: "#dfdfef",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "JavaScript }");

var _ref19 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(308.64 39.77)",
  fontSize: 14.52,
  fill: "#a9a9d8",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "=");

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 223.23,
  y: 57.99,
  width: 235.5,
  height: 140.58,
  rx: 2.81,
  fill: "#050517"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M313.66,179.52h0c-1.62-7.06,4.28-11.71,9.57-11.71H539.58c5.29,0,11.13,4.65,9.58,11.71h0",
  transform: "translate(-90.42 -113.69)",
  fill: "#3535bc"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 433.18,
  cy: 61.36,
  r: 1.7,
  fill: "#d6d6ed"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 440,
  cy: 61.36,
  r: 1.7,
  fill: "#d6d6ed"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 446.81,
  cy: 61.36,
  r: 1.7,
  fill: "#d6d6ed"
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  x1: 233.84,
  y1: 73.29,
  x2: 233.84,
  y2: 185.74,
  fill: "none",
  stroke: "#e1e1ef",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 78.4,
  r: 1.7,
  fill: "#7d7dd3"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 160.18,
  r: 1.7,
  fill: "#7d7dd3"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 88.62,
  r: 1.7,
  fill: "#d1d1f2"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 149.96,
  r: 1.7,
  fill: "#d1d1f2"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 98.84,
  r: 1.7,
  fill: "#5d5da3"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 109.07,
  r: 1.7,
  fill: "#428acc"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 180.63,
  r: 1.7,
  fill: "#428acc"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 170.4,
  r: 1.7,
  fill: "#428acc"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 119.29,
  r: 1.7,
  fill: "#a1c11e"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 129.51,
  r: 1.7,
  fill: "#841fbf"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 242.36,
  cy: 139.73,
  r: 1.7,
  fill: "#0d7cba"
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 78.4,
  x2: 301.99,
  y2: 78.4,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  x1: 373.55,
  y1: 109.07,
  x2: 433.18,
  y2: 109.07,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  x1: 363.33,
  y1: 129.51,
  x2: 422.96,
  y2: 129.51,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  x1: 310.51,
  y1: 88.62,
  x2: 375.25,
  y2: 88.62,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 149.96,
  x2: 303.69,
  y2: 149.96,
  fill: "none",
  stroke: "#ffeb17",
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 88.62,
  x2: 301.99,
  y2: 88.62,
  fill: "none",
  stroke: "#e8e5d1",
  strokeMiterlimit: 10
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 139.73,
  x2: 317.32,
  y2: 139.73,
  fill: "none",
  stroke: "#994154",
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("line", {
  x1: 325.84,
  y1: 139.73,
  x2: 388.88,
  y2: 139.73,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("line", {
  x1: 359.92,
  y1: 149.96,
  x2: 422.96,
  y2: 149.96,
  fill: "none",
  stroke: "#0b479e",
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("line", {
  x1: 315.62,
  y1: 78.4,
  x2: 363.33,
  y2: 78.4,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  x1: 347.99,
  y1: 119.29,
  x2: 412.74,
  y2: 119.29,
  fill: "none",
  stroke: "#419cce",
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  x1: 387.18,
  y1: 88.62,
  x2: 434.88,
  y2: 88.62,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 109.07,
  x2: 301.99,
  y2: 109.07,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  x1: 295.18,
  y1: 119.29,
  x2: 342.88,
  y2: 119.29,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  x1: 308.81,
  y1: 149.96,
  x2: 356.51,
  y2: 149.96,
  fill: "none",
  stroke: "#5cbfff",
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  x1: 254.29,
  y1: 129.51,
  x2: 301.99,
  y2: 129.51,
  fill: "none",
  stroke: "#660fb2",
  strokeMiterlimit: 10
});

var _ref53 = /*#__PURE__*/React.createElement("line", {
  x1: 312.21,
  y1: 129.51,
  x2: 359.92,
  y2: 129.51,
  fill: "none",
  stroke: "#906db5",
  strokeMiterlimit: 10
});

var _ref54 = /*#__PURE__*/React.createElement("line", {
  x1: 373.55,
  y1: 78.4,
  x2: 433.18,
  y2: 78.4,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
});

var _ref55 = /*#__PURE__*/React.createElement("line", {
  x1: 308.81,
  y1: 109.07,
  x2: 368.44,
  y2: 109.07,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  x1: 393.99,
  y1: 139.73,
  x2: 433.18,
  y2: 139.73,
  fill: "none",
  stroke: "#a3860d",
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("line", {
  x1: 257.02,
  y1: 96.67,
  x2: 254.29,
  y2: 103.96,
  fill: "none",
  stroke: "#b5b3a3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
});

var _ref58 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(256.95 102.53)",
  fontSize: 5.7,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*");

var _ref59 = /*#__PURE__*/React.createElement("line", {
  x1: 431.06,
  y1: 96.77,
  x2: 427.81,
  y2: 103.85,
  fill: "none",
  stroke: "#bfbba3",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
});

var _ref60 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(-1, 0, 0, 1, 428.13, 102.53)",
  fontSize: 5.7,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "*");

var _ref61 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(260.79 103.72)",
  fontSize: 17.04,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------");

var _ref62 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(342.56 103.72)",
  fontSize: 17.04,
  fill: "#898988",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, "--------------");

var _ref63 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(342.51 182.59)",
  fontSize: 27.26,
  fill: "#6d6de2",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "/ ");

var _ref64 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(56.58 147.1) scale(1.37 1)",
  opacity: 0.3,
  fontSize: 10.34,
  fill: "#9696e2",
  fontFamily: "Avenir-Black, Avenir",
  fontWeight: 800
}, "/ ");

var _ref65 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(402.35 178.37)",
  fontSize: 15.83,
  fill: "#4d4d8c",
  fontFamily: "Avenir-Light, Avenir",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  xmlSpace: "preserve"
}, " { }"));

var _ref66 = /*#__PURE__*/React.createElement("polyline", {
  points: "335.88 165.7 323.48 173.96 335.88 180.57",
  fill: "none",
  stroke: "#6d6de2",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref67 = /*#__PURE__*/React.createElement("polyline", {
  points: "357.36 165.7 369.75 173.96 357.36 180.57",
  fill: "none",
  stroke: "#6d6de2",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref68 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("polyline", {
  points: "53.76 139.26 47.88 143.85 53.76 147.52",
  fill: "none",
  stroke: "#8f8fe2",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polyline", {
  points: "63.94 139.26 69.82 143.85 63.94 147.52",
  fill: "none",
  stroke: "#8f8fe2",
  strokeMiterlimit: 10,
  strokeWidth: 3
}));

var _ref69 = /*#__PURE__*/React.createElement("polyline", {
  points: "423.89 32.41 429.84 36.37 423.89 39.55",
  fill: "none",
  stroke: "#dfdfed",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref70 = /*#__PURE__*/React.createElement("polyline", {
  points: "322.57 32.41 328.52 36.37 322.57 39.55",
  fill: "none",
  stroke: "#2a2acc",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref71 = /*#__PURE__*/React.createElement("polyline", {
  points: "321.75 32.41 327.7 36.37 321.75 39.55",
  fill: "none",
  stroke: "#2a2acc",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref72 = /*#__PURE__*/React.createElement("polyline", {
  points: "321.75 31.58 327.7 35.55 321.75 38.72",
  fill: "none",
  stroke: "#a9a9d8",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref73 = /*#__PURE__*/React.createElement("polyline", {
  points: "365.7 32.41 359.76 36.37 365.7 39.55",
  fill: "none",
  stroke: "#dfdfef",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

function SvgCoding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fcd6b31f-16e5-4a82-b883-e7aa46b2b47c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 458.99,
    height: 278.73,
    viewBox: "0 0 458.99 278.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coding") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.a696fc75.svg";
export { ForwardRef as ReactComponent };